import { TechnicalHolderType as TechnicalLicense } from 'packages/technical_holder_repository';
import { FieldType } from '../../../../types/reduxTypes/ActionTypes/TechnicalLicensesTypes';

export const types = {
  SET_FIELD: 'SET_FIELD',
  SET_ALL: 'SET_ALL',
}

export type SetAllType = {
  technicalLicense: TechnicalLicense,
};

export type SetFieldType = {
  field: FieldType,
  value: string | Blob,
}

export const setAll = (payload: SetAllType) => ({
  type: types.SET_ALL,
  payload,
});

export const setField = (payload: SetFieldType) => ({
  type: types.SET_FIELD,
  payload,
});
